import { render, staticRenderFns } from "./SchaefflerFooter.vue?vue&type=template&id=70f734c8&scoped=true"
import script from "./SchaefflerFooter.vue?vue&type=script&lang=js"
export * from "./SchaefflerFooter.vue?vue&type=script&lang=js"
import style0 from "./SchaefflerFooter.vue?vue&type=style&index=0&id=70f734c8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f734c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70f734c8')) {
      api.createRecord('70f734c8', component.options)
    } else {
      api.reload('70f734c8', component.options)
    }
    module.hot.accept("./SchaefflerFooter.vue?vue&type=template&id=70f734c8&scoped=true", function () {
      api.rerender('70f734c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SchaefflerFooter.vue"
export default component.exports